import React from 'react';
import { useSsoIdentifierWrapper } from 'src/components/enterprise/features/Employee/components/Form/controls/SsoIdentifierWrapper/hooks/useSsoIdentifierWrapper';
import { SsoUniqueIdentifierInput } from 'src/components/common/SsoUniqueIdentifierInput/SsoUniqueIdentifierInput';

export function SsoIdentifierWrapper(): JSX.Element {
  const { ssoEnabled, ssoUniqueIdentifier } = useSsoIdentifierWrapper();

  if (!ssoEnabled) {
    return null;
  }

  return (
    <SsoUniqueIdentifierInput
      id="ssoUniqueIdentifier"
      name="corpDinerSettings.ssoUniqueIdentifier"
      label={ssoUniqueIdentifier}
    />
  );
}
